import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiDialog-paper": {
      minHeight: "80vh",
      minWidth: "70%",
    },
    "& .MuiDialogTitle-root": {
      backgroundColor: theme.palette.custom.main,
      color: "#fff",
      padding: "8px 20px",
    },
    "& .MuiDialogTitle-root+.MuiDialogContent-root ": {
      paddingTop: 20,
    },
    "& .MuiDialogContent-root": {
      padding: "20px 20px",
    },
    "& .MuiDialogActions-root": {
      paddingInlineEnd: 24,
    },
  },
  dialogTitleContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  title: {
    color: "#fff",
    fontWeight: "500",
  },
  closeIcon: {
    color: "#fff",
  },
  closeBtn: {
    "& .MuiButtonBase-root": {
      backgroundColor: "#e5e5e5",
      textTransform: "capitalize",
      color: "#000",
      borderRadius: 20,
      padding: "6px 20px",
      "&:hover": {
        backgroundColor: "#e5e5e5",
      },
    },
  },
  avatarContainer: {
    paddingBlockEnd: 12,
    display: "flex",
    gap: 12,
    flexWrap: "wrap",
    alignItems: "center",
    "& .MuiAvatar-root": {
      width: 64,
      height: 64,
    },
  },
  name: {
    "& .MuiTypography-root": {
      fontWeight: 600,
    },
  },
  detailsContainer: {
    paddingBlockEnd: 12,
  },
  detailsWrapper: {
    display: "flex",
    paddingBlock: 4,
  },
  key: {
    "& .MuiTypography-root": {
      width: 220,
    },
  },
  value: {
    "& .MuiTypography-root": {
      color: "#7a7272",
    },
  },
  wrapper: {
    paddingBlockEnd: 12,
  },
  container: {
    boxShadow: "0px 5px 15px 5px rgb(0 0 0 / 10%)",
    padding: 20,
    borderRadius: 15,
    marginBlockEnd: 20,
    width: "100%",
  },
  label: {
    "& .MuiTypography-root": {
      color: "#d45a00",
    },
  },
  tabWrapper: {
    paddingBlock: 8,
    "& .MuiTab-root": {
      marginInlineEnd: 20,
      textTransform: "capitalize",
      padding: "12px 16px 12px 0px",
      fontSize: 16,
      fontWeight: 500,
      transition: "all ease .3s",
    },
    "& .MuiTabs-indicator": {
      height: 0,
    },
  },
  tableContainer: {
    paddingBlock: 20,
    "& .MuiDataGrid-root .MuiDataGrid-cell:focus-within": {
      outline: "none !important",
    },
    "& .MuiDataGrid-columnHeaders": {
      background: "#1D426D33",
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      fontWeight: 700,
      textTransform: "uppercase",
      //   fontSize: 16,
    },
    "& .MuiDataGrid-iconSeparator ": {
      display: "none",
    },
    "& .MuiDataGrid-virtualScroller": {
      scrollbarWidth: "thin",
      "&::-webkit-scrollbar": {
        height: 6,
      },
    },
    "& .MuiDataGrid-footerContainer": {
      justifyContent: "flex-start",
    },
    "& .MuiTablePagination-selectLabel": {
      fontSize: 14,
    },
    "& .MuiTablePagination-displayedRows": {
      fontSize: 14,
    },
  },
  lightText: {
    "& .MuiTypography-root": {
      color: "rgba(0, 0, 0, 0.7)",
    },
  },
  header: {
    "& .MuiTypography-root": {
      fontSize: 20,
      paddingBlockEnd: 12,
      textTransform: "capitalize",
      color: theme.palette.custom.main,
    },
  },
  fieldWrapper: {
    margin: "200px 0px",
  },
  timeFieldContainer: {
    paddingRight: "10px",
  },
  containerWrapper: {
    margin: "20px 10px",
  },
  timePickerStyle: {
    "& .MuiInputBase-input": {
      padding: "15px",
    },
  },
  avatarContainer: {
    width: "100%",
    height: 156,
    background: "#36577E33",
    borderRadius: 10,
    display: "flex",
    justifyContent: "center",
    position: "relative",
    marginBlockEnd: 116,
    [theme.breakpoints.down("sm")]: {
      height: 120,
      marginBlockEnd: 90,
    },
  },

  avatarWrapper: {
    position: "absolute",
    width: 170,
    height: 170,
    bottom: "-50%",
    [theme.breakpoints.down("lg")]: {
      width: 156,
      height: 156,
    },
    [theme.breakpoints.down("md")]: {
      width: 140,
      height: 140,
    },
    [theme.breakpoints.down("sm")]: {
      width: 120,
      height: 120,
    },
  },
  avatar: {
    width: "100%",
    height: "100%",
    border: "1px solid rgba(29, 66, 109, 0.5)",
    borderRadius: "100%",
    background: "#F3F3F3",
    position: "relative",
  },
  img: {
    width: "100%",
    height: "100%",
    borderRadius: "100%",
  },
  editIcon: {
    position: "absolute",
    right: -4,
    top: "61%",
    "& .MuiSvgIcon-root": {
      display: "flex",
      fontSize: 28,
      color: theme.palette.custom.main,
      cursor: "pointer",
    },
  },
  dialogActions: {
    display: "flex",
  },
  uploadAreaWrapper: {
    position: "relative",
    padding: "0px 80px",
  },
  fileUploadArea: {
    height: "300px",
    width: "100%",
    borderRadius: "8px",
    border: "3px dotted #00000026",
  },
  fileUploadContentsStyle: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
  },
  fileIconWrapper: {
    position: "relative",
  },
  uploadIconWrapper: {
    position: "absolute",
    bottom: "5px",
    right: "2px",
    background: "blue",
    borderRadius: "50%",
    width: "40px",
    height: "40px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "white",
  },
  formatInfoWrapper: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: "10px  ",
  },
  supportInfo: {
    marginTop: "10px",
    fontSize: "13px",
    color: "#717189ad",
  },
  fileSizeInfo: {
    marginTop: "10px",
    fontSize: "13px",
    color: "#717189ad",
  },
  previewDocumentWrapper: {
    width: "100%",
    height: "500px",
    marginTop: "30px",
    marginBottom: "20px",
  },
  documentViewerWrapper: {
    width: "100%",
    height: "100%",
  },
  header: {
    backgroundColor: "#343a40",
    color: "#fff",
    textAlign: "center",
    padding: "1em",
  },
  driverContainer: {
    maxWidth: "900px",
    margin: "20px auto",
    backgroundColor: "#fff",
    borderRadius: "8px",
    overflow: "hidden",
    boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
  },
  driverHeader: {
    backgroundColor: "#343a40",
    color: "#fff",
    padding: "1em",
  },
  driverImage: {
    textAlign: "center",
  },
  profileImage: {
    borderRadius: "50%",
    border: "4px solid #fff",
    boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
    width: "150px",
    height: "150px",
    objectFit: "cover",
    marginTop: "20px",
  },
  detailsSection: {
    padding: "1em",
  },
  sectionHeader: {
    color: "#343a40",
    borderBottom: "2px solid #343a40",
    paddingBottom: "0.5em",
    marginBottom: "1em",
  },
  keyValue: {
    display: "flex",
    justifyContent: "space-between",
    padding: "0.5em 0",
    borderBottom: "1px solid #ddd",
  },
  lastKeyValue: {
    borderBottom: "none",
  },
  key: {
    fontWeight: "bold",
    color: "#343a40",
  },
  value: {
    flexGrow: 1,
    textAlign: "right",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    marginTop: "1em",
  },
  tableHeader: {
    backgroundColor: "#343a40",
    color: "#fff",
  },
  tableRow: {
    borderBottom: "1px solid #ddd",
  },
  tableCell: {
    padding: "1em",
    textAlign: "left",
  },
  approveStatus: {
    color: "#28a745", // Green color for approved status
  },
  accessingStatus: {
    color: "#ffc107", // Yellow color for accessing status
  },
}));

export default useStyles;
